/**
 * Callback für den Standort-Picker der MapSection (Kartenklick ohne hinterlegte Fläche).
 * Liegt hier, damit Flächensicherung und Anlagen-Seite denselben Speicher-Vorgang nutzen.
 */
import { useCallback } from "react";
import { areasApi } from "../../../services/api/areas";
import { useToast } from "../../../contexts/ToastContext";

export function useStandortSpeichern(projectId: string) {
  const { showSuccess, showError } = useToast();

  return useCallback(
    async (breitengrad: number, laengengrad: number) => {
      try {
        await areasApi.updateProjectArea(projectId, {
          breitengrad,
          laengengrad,
        });
        showSuccess("Standort gespeichert");
      } catch {
        showError("Speichern fehlgeschlagen");
      }
    },
    [projectId, showSuccess, showError],
  );
}
